import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


//jquery
import '@/assets/common/js/jquery.js'

// import 'signalr'
import signalr from '@/assets/js/signalR.js'

Vue.use(signalr);

//全局方法
import '@/assets/common/js/prototype.js'
import '@/assets/common/js/instructions.js'
//ajax
import '@/assets/libs/ajax.js'
//element
import '@/assets/common/js/element-ui.js'
import '../theme/index.css';
import '@/assets/common/css/element.less';
//ztree
import '@/assets/plugins/ztree/jquery.ztree.core.js'
import '@/assets/plugins/ztree/jquery.ztree.excheck.min.js'
import '@/assets/plugins/ztree/jquery.ztree.exedit.min.js'
import '@/assets/plugins/ztree/metroStyle/metroStyle.css';
//自定义组件
import '@/assets/js/FComs.js';
import '@/assets/common/icon/iconfont.js'
import '@/components/LeftSource/LeftSource.vue'
import '@/components/CodeMirror/Codemirror.vue';

// //视频流插件
// import VideoPlayer from 'vue-video-player'
//
// require('videojs-flash');
// require('videojs-contrib-hls');
//
// require('video.js/dist/video-js.css');
// require('vue-video-player/src/custom-theme.css');
// Vue.use(VideoPlayer);




//富文本框
import QuillEditor from 'vue-quill-editor'

Vue.use(QuillEditor)
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.snow.css'


//数据关联关系
import SuperFlow from 'vue-super-flow'
import 'vue-super-flow/lib/index.css'


Vue.use(SuperFlow)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
